export enum KnownPermission {
  ADMIN = "admin",
  SUPERADMIN = "superadmin",
}
